module.exports = __webpack_public_path__ + "static/media/logo.38b304d7.png";